import * as React from "react";
import { FontIcon, FontSizes, FontWeights, IStackItemStyles, IStackTokens, mergeStyles, Spinner, SpinnerSize, Stack, Text } from "@fluentui/react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../redux";
import { setExpandedItem } from "../../redux/modules/expanders";
import { expanderConstants } from "../../redux/models/constants/expanders";
import { setContentManagerSelectedHomeSection } from "../../redux/modules/contentManagerDirectory";
import { ContentManagerHomeEnum } from "../enums/ContentManagerHomeEnum";
import { resetWorkingDirectories } from "../../redux/modules/workingDirectory";

const mapStateToProps = (state: RootState) => {
  return {
    expanders: state.expanders,
    selectedHomeSection: state.contentManagerDirectory.selectedHomeSection
  };
};

const mapDispatchToProps = { setExpandedItem, setContentManagerSelectedHomeSection, resetWorkingDirectories };

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
interface SubTitleProps extends PropsFromRedux {
  title: string;
  // iconName?: string;
  iconElement?: JSX.Element;
  itemsSelected?: number;
  expanderNameToToggle?: string;
  isWaitingOnContent?: boolean;
  selectedItemsMoreClicked?: () => void;
  clearFilterButton?: JSX.Element;
  filterButton?: JSX.Element;
  sortOptions?: JSX.Element;
  actionButton?: JSX.Element;
  canToggle?: boolean;
}

const containerStackTokens: IStackTokens = { childrenGap: 8 };

const stackItemStyles: IStackItemStyles = {
  root: {
    display: 'flex'
  },
};

const sectionIcon = mergeStyles({
  fontSize: 20,
});

const textRegular = mergeStyles({
  fontSize: FontSizes.size18,
  fontWeight: FontWeights.semibold,
});

const textSmall = mergeStyles({
  fontSize: FontSizes.size12,
  fontWeight: FontWeights.regular,
  paddingTop: 2
});

const SubTitle: React.FunctionComponent<SubTitleProps> = ({
  title,
  // iconName,
  iconElement,
  itemsSelected,
  expanders,
  expanderNameToToggle,
  setExpandedItem,
  isWaitingOnContent,
  selectedItemsMoreClicked,
  clearFilterButton,
  filterButton,
  sortOptions,
  actionButton,
  canToggle = true,
  setContentManagerSelectedHomeSection,
  selectedHomeSection,
  resetWorkingDirectories
}: SubTitleProps) => {
  const toggleExpander = () => {
    if (canToggle) {
      setExpandedItem({ toggle: !expanders[expanderNameToToggle], property: expanderNameToToggle });
    } else {
      resetWorkingDirectories(undefined, false);
      switch (expanderNameToToggle) {
        case expanderConstants.home.pinned:
          setContentManagerSelectedHomeSection(ContentManagerHomeEnum.Pinned)
          break;
        case expanderConstants.home.recent:
          setContentManagerSelectedHomeSection(ContentManagerHomeEnum.Recent)
          break;
        case expanderConstants.home.shared:
          setContentManagerSelectedHomeSection(ContentManagerHomeEnum.Shared)
          break;
        default:
          break;
      }
    }
  };

  const isSelectedItem = React.useMemo(() => {
    let noToggleClass = "xb-subtitle-container-notoggle";
    if (selectedHomeSection === ContentManagerHomeEnum.Pinned && expanderNameToToggle === expanderConstants.home.pinned) {
      noToggleClass = `${noToggleClass} xb-subtitle-container-notoggle-active`;
    }
    else if (selectedHomeSection === ContentManagerHomeEnum.Recent && expanderNameToToggle === expanderConstants.home.recent) {
      noToggleClass = `${noToggleClass} xb-subtitle-container-notoggle-active`;
    }
    else if (selectedHomeSection === ContentManagerHomeEnum.Shared && expanderNameToToggle === expanderConstants.home.shared) {
      noToggleClass = `${noToggleClass} xb-subtitle-container-notoggle-active`;
    }

    return noToggleClass;
  }, [canToggle, expanderNameToToggle, selectedHomeSection])

  return (
    <Stack
      className={`${canToggle ? "xb-subtitle-container" : isSelectedItem}`}
      horizontal={true}
      verticalAlign="center"
      tokens={containerStackTokens}
      onClick={toggleExpander}
    // style={{backgroundColor: "red"}}
    >
      <Stack.Item styles={stackItemStyles}>
        {canToggle && <FontIcon iconName={expanders[expanderNameToToggle] ? "ChevronRight" : "ChevronDown"} />}
      </Stack.Item>
      <Stack.Item grow styles={stackItemStyles}>
        <Stack horizontal verticalAlign="center" horizontalAlign="start" tokens={containerStackTokens}>
          {/* {iconName && <FontIcon iconName={iconName} className={sectionIcon} />} */}
          {iconElement}
          <Text className={textRegular}>{title}</Text>
          {itemsSelected > 0 && (
            <>
              <Text className={textSmall} style={{ marginLeft: 5 }}>({itemsSelected} selected)</Text>
              <span style={{ marginLeft: 5, paddingTop: 5 }} onClick={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => { event.stopPropagation(); selectedItemsMoreClicked(); }}>
                <FontIcon iconName="More" />
              </span>
            </>
          )}
        </Stack>
      </Stack.Item>
      {isWaitingOnContent && <Stack.Item styles={stackItemStyles}>
        <Spinner key={"waitSpinner"} size={SpinnerSize.small} styles={{
          root: {
            height: 25,
            width: 26
          }
        }} />
      </Stack.Item>}
      {!isWaitingOnContent && actionButton && <Stack.Item styles={stackItemStyles}>
        {actionButton}
      </Stack.Item>}
      {clearFilterButton && <Stack.Item styles={stackItemStyles}>
        {clearFilterButton}
      </Stack.Item>}
      {filterButton && <Stack.Item styles={stackItemStyles}>
        {filterButton}
      </Stack.Item>}
      {sortOptions && <Stack.Item styles={stackItemStyles}>
        {sortOptions}
      </Stack.Item>}
    </Stack>
  );
};
export default connector(SubTitle);
